import { useThree } from '@react-three/fiber';

export const useGLSettings = ({ exposure = 1 }) => {
  const { gl } = useThree();
  gl.toneMappingExposure = exposure;
  gl.antialias = true;
};
